import { DayPart } from "../../gql/types";

export interface TimeSelectionRow {
    id: number;
    date: string;
    startTime: string;
    endTime: string;
}

export interface TimeOption {
    value: string; // Machine-readable value (e.g., "03:00")
    label: string; // Human-readable label (e.g., "03:00 AM")
}

export interface ProposedDate {
    /** e.g., "2025-01-20" */
    dateString: string;
    /** Exactly one daypart per ProposedDate */
    dayPart: DayPart;
    /** Optional banner text (e.g., "Most Popular") */
    bannerText?: string;
    recommendation?: RecommendationStatus;
}

/** The user's selection of a single date + daypart */
export interface DayPartSelection {
    selectedDate: string;
    selectedDayPart: DayPart;
}

/** For time-based selections (unchanged) */
export interface TimeSelectionRow {
    id: number;
    date: string;
    startTime: string;
    endTime: string;
}

export enum RecommendationStatus {
    Recommended = "recommended",
    Neutral = "neutral",
    NotRecommended = "notRecommended",
}

export interface DayPartRowType {
    id: number;
    date: string;
    selectedDayParts: DayPart[];
}

export interface SelectedDayPartPair {
    date: string;
    dayPart: DayPart;
}